import * as React from 'react';
import { reactPlugin } from "../../AppInsights";
import { SeverityLevel } from "@microsoft/applicationinsights-web";

class ErrorBoundary extends React.Component<any, { error: any, errorInfo: any }> {
    constructor(props) {
      super(props);
      this.state = { error: undefined, errorInfo: undefined };
    }
    
    componentDidCatch(error, errorInfo) {
      // Catch errors in any components below and re-render with error message
      this.setState({
        error: error,
        errorInfo: errorInfo
      })
      // You can also log error messages to an error reporting service here
      reactPlugin.trackException({ error: error, exception: errorInfo, severityLevel: SeverityLevel.Error });
    }
    
    render() {
      if (this.state.errorInfo) {
        // Error path
        if (  this.props.errorComponent )
          return <>{this.props.errorComponent}</>
          
        return (
          <div style={{ width: '100%', height: '100%', padding: '5px', color: '#e10000', backgroundColor: '#fff0f0', fontFamily: 'Consolas,monaco,monospace' }} >
            <h2>Something went wrong.</h2>
            <span>
              {this.state.error && this.state.error.toString()}
              <br />
              {this.state.errorInfo.componentStack}
            
            </span>
          </div>
        );
      }
      // Normally, just render children
      return this.props.children;
    }  
  }
  

  export default ErrorBoundary;

  export class SmallErrorBoundary extends React.Component<any, { error: any, errorInfo: any }> {
    constructor(props) {
      super(props);
      this.state = { error: undefined, errorInfo: undefined };
    }
    
    componentDidCatch(error, errorInfo) {
      // Catch errors in any components below and re-render with error message
      this.setState({
        error: error,
        errorInfo: errorInfo
      })
      // You can also log error messages to an error reporting service here
      reactPlugin.trackException({ error: error, exception: errorInfo, severityLevel: SeverityLevel.Error });
    }
    
    render() {
      if (this.state.errorInfo) {
        // Error path
        return (
          <div style={{ width: '100%', height: '100%', padding: '5px', color: '#e10000', backgroundColor: '#fff0f0', fontFamily: 'Consolas,monaco,monospace' }} >
            <span>
              An error occured while loading this component
            </span>
          </div>
        );
      }
      // Normally, just render children
      return this.props.children;
    }  
  }
  